"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var keycodes_1 = require("./keycodes");

exports.USER_SCROLL_EVENTS = ['mousedown', 'wheel', 'DOMMouseScroll', 'mousewheel', 'touchmove'];
exports.USER_SCROLL_KEYBOARD_EVENTS = [keycodes_1.EKeyCodes.SpaceBar, keycodes_1.EKeyCodes.PageUp, keycodes_1.EKeyCodes.PageDown, keycodes_1.EKeyCodes.End, keycodes_1.EKeyCodes.Home, keycodes_1.EKeyCodes.Left, keycodes_1.EKeyCodes.Up, keycodes_1.EKeyCodes.Right, keycodes_1.EKeyCodes.Down];